<ef-indirect-rate-structure
    [items]="rateStructures$ | async"
    [rates]="rateTypes$ | async"
    [userInfo]="userInfo$ | async"
    [selectedError]="selectedError"
    [showAdjustments]="showAdjustments"
    [FiscalYearEndDate]="FiscalYearEndDate"
    [disabled]="disabled"
    (ShowError)="ShowError.next($event)"
    (SaveItem)="onSaveItem($event)"
    (DeleteItem)="onDeleteItem($event)"
></ef-indirect-rate-structure>
